var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',{staticClass:"extra"},[_c('app-wrapper',{staticClass:"extra-content",attrs:{"text":true,"content":true,"inverse":true}},[_c('h2',[_vm._v(_vm._s(_vm.$state.page.extra_title))]),_c('app-text',{staticClass:"extra-text",attrs:{"text":_vm.$state.page.extra_content}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }